import React, { useEffect, useCallback, useState } from 'react';
import { Link, useHistory } from 'react-router-dom';

interface Props {
  to: string;
  delay?: number;
  replace?: boolean;
  onDelayStart?: (e: number, to: string) => void;
  onDelayEnd?: () => void;
  children?: any;
}

export const DelayLink: React.FC<Props> = ({
  to,
  delay = 500,
  replace,
  onDelayStart = () => {},
  onDelayEnd = () => {},
  children,
}) => {
  let [isTimeOut, setIsTimeout] = useState(false);
  let history = useHistory();

  useEffect(() => {
    if (isTimeOut) {
      let delayTimeOut = setTimeout(() => {
        if (replace) {
          history.replace(to);
        } else {
          history.push(to);
        }
        onDelayEnd();
      }, delay);

      return () => clearTimeout(delayTimeOut);
    }
  }, [delay, history, onDelayEnd, replace, to, isTimeOut]);
  const handleClick = useCallback(
    e => {
      onDelayStart(e, to);
      if (e.defaultPrevented) {
        return;
      }
      e.preventDefault();
      setIsTimeout(true);
    },
    [to, onDelayStart],
  );

  return (
    <Link to={to} onClick={handleClick} replace={replace}>
      {children}
    </Link>
  );
};
